<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="flight-number">Flight Number</label>
        <input
          id="flight-number"
          type="text"
          v-model="$parent.flight.flight_number"
        />
      </div>

      <div>
        <label for="departure_airport_id">Departure Airport</label>
        <v-select
          id="departure_airport_id"
          label="airport_name"
          :filterable="false"
          :options="departure_airports"
          v-model="selectedDepartureAiport"
          v-debounce:500ms="searchDepartureAirports"
        > 
          <template slot="option" slot-scope="option" >
            {{ option.iata_code }} - {{ option.airport_name }}
          </template>
        </v-select>
      </div>

      <div>
        <label for="arrival_airport_id">Arrival Airport</label>
        <v-select
          id="arrival_airport_id"
          label="airport_name"
          :filterable="false"
          :options="arrival_airports"
          v-model="selectedArrivalAiport"
          v-debounce:500ms="searchArrivalAirports"
        >
          <template slot="option" slot-scope="option">
            {{ option.iata_code }} - {{ option.airport_name }}
          </template>
        </v-select>
      </div>
      
      <div>
        <label for="departure_terminal">Departure Terminal</label>
        <input 
          title="departure_terminal"
          type="text"
          id="depature_terminal"
          placeholder=""
          v-model="$parent.flight.departure_terminal"
        />
      </div>

      <div>
        <label for="arrival_terminal">Arrival Terminal</label>
        <input 
          title="arrival_terminal"
          type="text"
          id="arrival_terminal"
          placeholder=""
          v-model="$parent.flight.arrival_terminal"
        />
      </div>      

      <div>
        <label for="flight_cost">Flight Cost</label>
        <input 
          title="flight_cost"
          type="text"
          id="flight_cost"
          placeholder=""
          v-model="$parent.flight.flight_cost"
        />
      </div>

      <div>
        <label for="flight_price">Flight Price</label>
        <input 
          title="flight_price"
          type="text"
          id="flight_price"
          pacholder=""
          v-model="$parent.flight.flight_price"
        />
      </div>      

      <div>
        <label for="departure-time">
          {{ (showTimeForDates) ? 'Departure Time' : 'Departure Date' }}
        </label>
        <dateTimePicker 
          id="departure-time" 
          :format="showTimeForDates ? 'HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss'"  
          :formatted="showTimeForDates ? 'hh:mm A' : 'YYYY-MM-DD hh:mm A'"
          v-model="$parent.flight.departure_time" 
          button-color="#ec391e" color="#ec391e"
          :only-time="showTimeForDates"
          style="border: 1px solid #DFE5F9"/>
      </div>

       <div>
        <label for="arrival-time">{{ (showTimeForDates) ? 'Arrival Time' : 'Arrival Date' }}</label>
        <dateTimePicker 
          id="arrival-time" 
          :format="showTimeForDates ? 'HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss'" 
          :formatted="showTimeForDates ? 'hh:mm A' : 'YYYY-MM-DD hh:mm A'"
          v-model="$parent.flight.arrival_time" 
          button-color="#ec391e" color="#ec391e"
          :only-time="showTimeForDates"
          style="border: 1px solid #DFE5F9"/>
      </div>

      <div>
        <label for="airline">Airline</label>
        
        <select v-model="$parent.flight.airline">
            <option value="">Select Airline</option>
            <option v-for="airline in airlines" :value="airline.id" :key="airline.id">{{ airline.name }}</option>
        </select>
      </div>

      <div>
        <label for="stop-sell">Stop sell</label>
        <label class="switch">
          <input id="stop-sell" name="stop_sell" type="checkbox" v-model="$parent.flight.stop_sell">
          <span class="switch__slider"></span>
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'FlightFields',
  props: {
    showTimeForDates: {
      type: Boolean,
      default:false
    },
    airlines: {
      type: Array,
      default:[]
    },
  },
  watch: {
    selectedDepartureAiport: function (val) {
      this.$parent.flight.departure_airport_id = val.id
    },
    selectedArrivalAiport: function (val) {
      this.$parent.flight.arrival_airport_id = val.id
    }
  },
  async created() {
    await this.defaultSearchAirPorts('departure',this.$parent.flight.departure_airport_id)
    await this.defaultSearchAirPorts('arrival', this.$parent.flight.arrival_airport_id)
    
    if (this.$parent.flight.departure_airport) {
      this.selectedDepartureAiport = this.$parent.flight.departure_airport
    }
    if (this.$parent.flight.arrival_airport) {
      this.selectedArrivalAiport = this.$parent.flight.arrival_airport
    }
  },
  data () {
    return {
      loading: false,
      departure_airports: [],
      arrival_airports: [],
      selectedDepartureAiport: {},
      selectedArrivalAiport: {},
    }
  },
  methods: {
    searchDepartureAirports(search = null) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'airports/search/' + search, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.departure_airports = response.data
          this.$data.loading = false
        })
      }
    },
    searchArrivalAirports (search = null) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'airports/search/' + search, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.arrival_airports = response.data
          this.$data.loading = false
        })
      }
    },
    defaultSearchAirPorts(type, include_id) {
      let __this = this
      fetch(this.$api + 'airports/airport-search', {
          method: 'POST',
          body: JSON.stringify({
            search_query: null,
            include_id
          }), 
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if (type == 'deaparture') {
            __this.departure_airports = response.data
          } else {
            __this.arrival_airports = response.data
            
          }
        })
    }
  }
}
</script>
